<template lang="html">
  <d-row class="feed_container">
    <d-col cols="12" v-for="(post, index) in posts.list" :key="index" >
      <d-card class="card-small mb-3">
        <d-card-body>
          <d-row class="w-100">
            <d-col cols="2">
              <children-media :post="post.children.data" v-if="post.children"></children-media>
              <item-media :post="post" v-else />
            </d-col>
            <d-col cols="10">
              <div class="description">
                <p class="caption">
                  <span v-if="post.caption" v-html="post.caption.replace('\n', '<br/>')"></span>
                </p>
                <div class="bottom">
                  <div class="counts d-flex mr-4">
                    <span class=" mr-4"><i class="fa fa-heart"></i> {{ post.like_count }}</span>
                    <span class=" mr-4"><i class="fa fa-comment"></i> {{ post.comments_count }}</span>
                    <div class="tags">
                      Tags: {{ post.tags.map(item => item.name).join(', ') }}
                    </div>
                  </div>
                  <div class="link">
                    <d-link :href="post.permalink" target="_blank">{{ post.permalink }}</d-link>
                  </div>
                </div>
              </div>
            </d-col>
          </d-row>
        </d-card-body>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ChildrenMedia from '_modules/feed/components/ChildrenMedia';
import ItemMedia from '_modules/feed/components/ItemMedia.vue';
import { _LOAD_REPORT_TAGS_ } from './TagModel';

export default {
  name: 'tag-list-items',
  components: {
    ChildrenMedia,
    ItemMedia,
  },
  data() {
    return {
      posts: [],
    };
  },
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
    ]),
  },
  mounted() {
    Events.$on(_LOAD_REPORT_TAGS_, feed => {
      this.posts = feed;
    });
  },
};
</script>

<style lang="scss" scoped>
.feed_container {
  margin-top: 20px;;
  .card {
    .card-body {
      width: 100%;
      align-items: center;
      overflow: hidden;
      display: flex;
      .description {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        align-items: bottom;
        .caption {
          height: 90%;
        }
        .bottom {
          height: 10%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
